/* Etichette leggibili per gli step, usate dalla step-list. */
import { firstLine, plain, type DiagramDoc, type FlowStep } from "@fullsteps/shared";

export const STEP_LABEL: Record<FlowStep["t"], string> = {
  phase: "Fase",
  note: "Nota",
  msg: "Messaggio",
  act: "Attiva",
  deact: "Disattiva",
  create: "Crea attore",
  destroy: "Distruggi attore",
  block: "Blocco",
  else: "Ramo (else)",
  end: "Fine blocco",
};

export function stepSummary(step: FlowStep, doc: DiagramDoc): string {
  const name = (id: string): string => doc.participants.find((p) => p.id === id)?.name ?? id;
  switch (step.t) {
    case "phase":
      return step.title;
    case "note":
      return `su ${name(step.over)}: ${firstLine(step.text)}`;
    case "msg":
      return `${name(step.from)} → ${name(step.to)}: ${firstLine(step.text) || "(vuoto)"}`;
    case "act":
      return name(step.a);
    case "deact":
      return name(step.a);
    case "create":
      return name(step.a) + (step.inline ? " (inline)" : "");
    case "destroy":
      return name(step.a);
    case "block":
      return `${step.kind.toUpperCase()} [${plain(step.cond)}]`;
    case "else":
      return `[${plain(step.cond)}]`;
    case "end":
      return "";
  }
}

/** Profondità di annidamento di ogni step (per l'indentazione della step-list). */
export function depths(flow: FlowStep[]): number[] {
  const out: number[] = [];
  let depth = 0;
  for (const s of flow) {
    if (s.t === "end") depth = Math.max(0, depth - 1);
    if (s.t === "else") out.push(depth - 1);
    else out.push(depth);
    if (s.t === "block") depth++;
  }
  return out;
}
